import { handleActions } from 'redux-actions';
import { DeviationPageState } from './types';
import { reduxKey, defaultState } from './constants';
import { setScreenSize, initStash, postPublishTrigger } from './actions';

const actionHandlers = handleActions<DeviationPageState, any>(
  {
    [setScreenSize.toString()]: (
      state,
      action: ReturnType<typeof setScreenSize>
    ) => ({
      ...state,
      viewOptions: {
        ...state.viewOptions,
        screenSize: action.payload,
      },
    }),
    [initStash.toString()]: (state, action: ReturnType<typeof initStash>) => ({
      ...state,
      stash: action.payload.stash,
    }),
    [postPublishTrigger.toString()]: state => ({
      ...state,
      postPublish: true,
    }),
  },
  defaultState
);

export default {
  [reduxKey as string]: actionHandlers,
};
